// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'object-case';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M7 14H4m11.188-7.812v-1.25a1.125 1.125 0 0 0-1.126-1.125H8.189V2.688a1.125 1.125 0 0 0-1.126-1.125H3.688a1.125 1.125 0 0 0-1.124 1.125v10.1a1.275 1.275 0 0 0 2.501.328l1.764-6.115a1.125 1.125 0 0 1 1.081-.814h8.404A1.125 1.125 0 0 1 17.4 7.603' />
    <path d='m17.1 12.76-3.04-3.04a.642.642 0 0 0-.44-.2H8.94l2.6 3.2c.12.12.12.32 0 .44l-2.6 3.2h4.68c.16 0 .32-.08.44-.2l3.04-3.04c.12-.04.12-.2 0-.36z' />
  </g>
);

export const viewBox = '0 0 18 18';
